import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { memo } from "react";
import { useRadioGroup } from "react-aria";
import { useRadioGroupState } from "react-stately";
import { RadioContext } from "./RadioContext.js";
import { RadioControl } from "./RadioControl.js";
import { toEnumStateClass } from "../../../utils/toEnumStateClass.js";
import { toEnumViewClass } from "../../../utils/toEnumViewClass.js";
function deriveAriaValidationState(validationState) {
  if (validationState === "valid") {
    return "valid";
  }
  if (validationState === "invalid") {
    return "invalid";
  }
  return void 0;
}
const Radio = memo((props) => {
  const { name, options, orientation, size, validationState, RadioButtonComponent } = props;
  const ariaRadioGroupProps = {
    ...props,
    validationState: deriveAriaValidationState(validationState)
  };
  const state = useRadioGroupState(ariaRadioGroupProps);
  const { radioGroupProps } = useRadioGroup(ariaRadioGroupProps, state);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: useClassName("radio", [
        toEnumStateClass(validationState),
        toEnumViewClass(orientation ?? "vertical")
      ]),
      ...radioGroupProps,
      children: /* @__PURE__ */ jsx(RadioContext.Provider, { value: state, children: options.map(({ value, label, labelDescription }) => /* @__PURE__ */ jsx(
        RadioControl,
        {
          RadioButtonComponent,
          name,
          value,
          validationState,
          description: labelDescription,
          size,
          children: label
        },
        value
      )) })
    }
  );
});
Radio.displayName = "Radio";
export {
  Radio
};
//# sourceMappingURL=Radio.js.map
